import { useEffect } from 'react';
import { useAlert } from '../../contexts/AlertContext';
import { initializeAlertOverride } from '../../utils/alertOverride';

/**
 * Component that initializes the alert override system after the AlertProvider is mounted.
 * This should be placed inside the AlertProvider.
 */
const AlertInitializer: React.FC = () => {
  const { showAlert, showConfirm } = useAlert();

  useEffect(() => {
    // Initialize the alert override with the context functions
    initializeAlertOverride({
      showAlert,
      showConfirm,
    });
  }, [showAlert, showConfirm]);

  return null;
};

export default AlertInitializer;

